export default __webpack_public_path__ + "static/media/Users1.c646f235.svg";